import { showConfirmation } from '../lib/confirmation';
import FieldLabel from '../components/ui/FieldLabel'
import UiInput from '../components/ui/Input'
import Button from '../components/ui/Button'
import React, { useEffect, useState } from "react";
import BrandLogo from "../components/BrandLogo";
import { auth } from "../firebase-config";
import {
    signInWithEmailAndPassword,
    onAuthStateChanged,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setUid } from "../redux/userReducer";
import { useDispatch } from "react-redux";
import { checkEmailInValid, postWithoutAuth } from "../common";
import LoadingPopup from "../components/LoadingPopup";

const Login = () => {

    const [mode, setMode] = useState('Login')
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = async () => {
        try {
            setLoading(true);
            const { user } = await signInWithEmailAndPassword(auth, email, password);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.error("Login error:", e);
            toast.error("Check your credentials.");
        }
    };

    const handleResetPassword = async () => {
        if (!email || checkEmailInValid(email)) {
            toast.error("Please enter your email.");
            return;
        }
        try {

            setLoading(true)
            await postWithoutAuth('sendResetPasswordEmail', { email: email.trim() })
            showConfirmation("Password reset email sent. Check spam folder as well.");

            setLoading(false)
        } catch (e) {
            console.error("Password reset error:", e);
            toast.error("Unable to send reset email. Please check the email address.", {
                position: "top-center",
            });
            setLoading(false)
        }
    };

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                dispatch(setUid(user.uid));
                navigate("/");
            }
        });

        return () => unsubscribe();
    }, [dispatch, navigate]);

    const isReset = mode !== 'Login'

    return (
        <>
        <LoadingPopup visible={loading} message={isReset ? "Sending reset email..." : "Signing in..."} />
        <div className="authShell">
            <div className="authCard">
                <div className="authBrand">
                    <div className="authBrandText">
                        <div className="authBrandTitle" style={{ lineHeight: 1 }}>
                            <BrandLogo height={28} />
                        </div>
                        <div className="authBrandSubtitle">Simply Managed.</div>
                    </div>
                </div>

                <div className="authCardBody">
                    <h1 className="authTitle">{isReset ? 'Reset password' : 'Sign in'}</h1>
                    <p className="authSubtitle">
                        {isReset
                            ? 'Enter your email and we’ll send you a reset link.'
                            : 'Sign in to manage clients, sites, allocations, timesheets, workers and more.'}
                    </p>

                    <FieldLabel className="fieldLabel" htmlFor="email">Email</FieldLabel>
                    <UiInput
                        type="email"
                        id="email"
                        required
                        name="email"
                        placeholder="email@domain.com.au"
                        value={email}
                        onChange={({ target }) => setEmail(target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') isReset ? handleResetPassword() : handleLogin()
                        }}
                    />

                    {!isReset && (
                        <>
                            <FieldLabel className="fieldLabel" htmlFor="password">Password</FieldLabel>
                            <UiInput
                                type="password"
                                id="password"
                                required
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={({ target }) => setPassword(target.value)}
                                onKeyDown={(event) => { if (event.key === 'Enter') handleLogin() }}
                            />
                        </>
                    )}

                    <Button variant="secondary" size="md"
                        className="authSubmit"
                        disabled={loading}
                        onClick={isReset ? handleResetPassword : handleLogin}
                    >
                        {loading ? 'Loading…' : isReset ? 'Reset Password' : 'Login'}
                    </Button>

                    <Button data-action-tone="back" variant="secondary" size="md"
                        type="button"
                        className="authTextLink"
                        onClick={() => setMode(isReset ? 'Login' : 'Reset Password')}
                    >
                        {isReset ? 'Back to login' : 'Forgot password?'}
                    </Button>
                </div>

                <div className="authCardFooter">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <span aria-hidden="true">·</span>
                    <Link to="/support">Support</Link>
                </div>
            </div>
        </div>
        </>
    );
};

export default Login;
